import { fetchEstablishments } from "./establishments/EstablishmentsActions";
import schemaJsonMetamodel from "./schema.json";

export const SURVEY_GET_PERIODS_STARTED = "SURVEY_GET_PERIODS_STARTED";
export const SURVEY_GET_PERIODS_SUCCESS = "SURVEY_GET_PERIODS_SUCCESS";
export const SURVEY_DATA_RECEIVED = "SURVEY_DATA_RECEIVED";
export const SURVEY_DATA_UDPATE = "SURVEY_DATA_UDPATE";
export const SURVEY_GET_PERIODS_FAILED = "SURVEY_GET_PERIODS_FAILED";
export const SEND_DATA_ERROR = "SEND_DATA_ERROR";
export const NO_DATA_ACTION = "NO_DATA_ACTION";
export const INFO_MESSAGE = "INFO_MESSAGE";
export const CLEAR_INFOR_AND_ERRO_MESSAGES = "CLEAR_INFOR_AND_ERRO_MESSAGES";
export const SURVEY_YEAR_CHANGED = "SURVEY_YEAR_CHANGED";
export const getSurveyPeriods = () => {
    return (dispatch, getState) => {

        dispatch(getSurveyPeriodsStarted());

        return fetch("/ndapmoci/survey/periods", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + getState().loginReducer.loginData.token
            }
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.status);
                }
                return response;
            })
            .then(response => response.json())
            .then(responseJson => {
                dispatch(getSurveyPeriodsSuccess(responseJson));
                if(getState().loginReducer.loginData && getState().loginReducer.loginData.searchId && getState().loginReducer.loginData.type === "S") {
                    dispatch(getSurveyData({year: responseJson.years[0].year, searchId: getState().loginReducer.loginData.searchId}));
                }
            
                if(getState().loginReducer.loginData && getState().loginReducer.loginData.type === "A") {
                    dispatch(fetchEstablishments(true));
                }

            })
            .catch(error => {
                if (error.message === '401') {
                    dispatch({ type: 'LOGOUT_ACTION' })
                }
                dispatch(getSurveyPeriodsFailed(error));
                console.error(error);
            });
    };
};

export const getSurveyPeriodsStarted = () => {
    return {
        type: SURVEY_GET_PERIODS_STARTED
    };
};
export const getSurveyPeriodsSuccess = (periods) => {
    return {
        type: SURVEY_GET_PERIODS_SUCCESS,
        periods
    };
};

export const getSurveyPeriodsFailed = (error) => {
    return {
        type: SURVEY_GET_PERIODS_FAILED,
        error
    };
};

export const submitSurveyData = (data, type) => {
    return (dispatch, getState) => {

        return fetch("/ndapmoci/survey/" + type, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + getState().loginReducer.loginData.token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.status);
                }
                return response;
            })
            .then(response => response.json())
            .then(responseJson => {
                dispatch(onInfoMessage("response_" + type));                               
                if(getState().loginReducer.loginData && getState().loginReducer.loginData.searchId && getState().loginReducer.loginData.type === "S") {
                    dispatch(getSurveyData({year: getState().dynamicSurveyReducer.selectedYear, searchId: getState().loginReducer.loginData.searchId}));
                }

                if(getState().loginReducer.loginData && getState().loginReducer.loginData.type === "A") {
                    let selected = getState().establishmentsReducer.surveyEstablishments.filter(x => x.selected);
                    if(selected && selected[0] && selected[0].search_id) {
                        dispatch(getSurveyData({year: getState().dynamicSurveyReducer.selectedYear, searchId: selected[0].search_id}));
                    }
                }

            })
            .catch(error => {
                if (error.message === '401') {
                    dispatch({ type: 'LOGOUT_ACTION' })
                }
                console.error(error);
                dispatch(errorOnSendData(error.message));
            });
    };
}

export const onInfoMessage = (message) => {
    return {
        type: INFO_MESSAGE,
        message
    };
}

export const errorOnSendData = (error) => {
    return {
        type: SEND_DATA_ERROR,
        error
    };
}

export const clearInfoAndErrorMessages = () => {
    return {
        type: CLEAR_INFOR_AND_ERRO_MESSAGES
    };
}

export const getSurveyData = (data) => {
    return (dispatch, getState) => {

        return fetch("/ndapmoci/survey/data", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + getState().loginReducer.loginData.token
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.status);
                }
                return response;
            })
            .then(response => response.json())
            .then(responseJson => {
                dispatch(surveyDataReceived(responseJson))
            })
            .catch(error => {
                if (error.message === '401') {
                    dispatch({ type: 'LOGOUT_ACTION' })
                }
                else if (error.message === '400') {
                    dispatch({ type: 'NO_DATA_ACTION' })
                }
                console.error(error);
            });
    };
}

export function selectNewYear(selectedYear) {
    return (dispatch, getState) => {
        dispatch(surveyYearChanged(selectedYear));
        let selected = getState().establishmentsReducer.surveyEstablishments.filter(x => x.selected);
        if (getState().loginReducer.loginData.type === "S") {
            dispatch(getSurveyData({ year: selectedYear, searchId: getState().loginReducer.loginData.searchId }));
        }
        else if (selected && selected[0] && selected[0].search_id) {
            dispatch(getSurveyData({ year: selectedYear, searchId: selected[0].search_id }));
        }
    }
}

export const surveyDataReceived = (data) => {

    return {
        type: SURVEY_DATA_RECEIVED,
        data
    }
}

export const surveyDataUpdate = (data, name) => {
    return {
        type: SURVEY_DATA_UDPATE,
        data,
        name
    }
}

export const surveyYearChanged = (selectedYear) => {
    return {
        type: SURVEY_YEAR_CHANGED,
        selectedYear
    }
}


let schemaJsonMetamodelKeys = Object.keys(schemaJsonMetamodel.lookup);
schemaJsonMetamodelKeys.map(lookupKey => {
	schemaJsonMetamodel.lookup[lookupKey] = [...schemaJsonMetamodel.lookup[lookupKey].map(x => ({ key: x[0], value: x[0], text: x[0] !== "" ? x[1] + " (" + x[0] + ")" : "", realtext: x[1], ...x[2] }))];
	return lookupKey;
});

export const possibleFieldTypes = {
	DISPLAY: "display",
	STRING: "string",
	TINYINT: "tinyint",
	INT: "int",
	SMALLINT: "smallint",
    BOOLEAN: "boolean",
    LONGITUDE: "longitude",
    LATITUDE: "latitude",
	LOOKUP: "lookup",
	CALCULATED: "calculated",
	CALCULATED_LATER: "calculated-later"
};

export { schemaJsonMetamodel };


// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/DynamicSurveyActions.js